import { Skeleton } from "@mui/material";

const OccupiedTraySkeleton = () => (
  <div
    style={{
      backgroundColor: "#E77B7B1A",
      borderRadius: "0.4vw",
      width: "10.25vw",
      alignItems: "start",
      padding: "0.5vw 1vw",
      display: "flex",
      flexDirection: "column",
      gap: "0.4vw",
      fontFamily: "Poppins",
    }}>
    <Skeleton
      variant="text"
      width="60%"
      height={20}
      sx={{ bgcolor: "#E77B7B33" }}
    />
    <div
      style={{
        display: "flex",
        gap: "0.4vw",
        alignItems: "center",
        width: "100%",
      }}>
      <Skeleton
        variant="circular"
        width={15}
        height={15}
        sx={{ bgcolor: "#fff2" }}
      />
      <Skeleton
        variant="text"
        width="100%"
        height={16}
        sx={{ bgcolor: "#fff2" }}
      />
    </div>
    <div
      style={{
        display: "flex",
        gap: "0.4vw",
        alignItems: "center",
        width: "100%",
      }}>
      <Skeleton
        variant="circular"
        width={15}
        height={15}
        sx={{ bgcolor: "#fff2" }}
      />
      <Skeleton
        variant="text"
        width="100%"
        height={16}
        sx={{ bgcolor: "#fff2" }}
      />
    </div>
  </div>
)

export default OccupiedTraySkeleton;